import { LocationType } from '@prisma/client';

/**
 * M2-D56 — só mesa chama garçom: garçom vai até um LUGAR.
 *
 * Comanda física (`TAB`) anda com o cliente pelo salão, e acomodação (`ROOM`) é serviço de quarto, em que
 * o próprio pedido já é o chamado. Uma função só para as duas pontas: a tela esconde o botão e o servidor
 * recusa com a mesma regra — abrir para outro tipo é mudar aqui.
 */
export function canCallWaiter(locationType: LocationType | null | undefined): boolean {
  return locationType === LocationType.TABLE;
}
